import {request} from '../helpers/request'
import LoadingComponent from './common/LoadingComponent'
import React from 'react'
import _ from 'lodash'
import Immutable from 'immutable'
import FieldComponent from './common/FieldComponent'
import ModalComponent from './common/ModalComponent'
import $ from 'jquery'
import {makeGrids} from '../helpers/makeGrids.js'
import {redirectIfNotLoggedIn, isAgent, getAccessLevel} from '../helpers/access'
import {Panel, ListGroup, ListGroupItem, Button, ButtonGroup, ButtonToolbar} from 'react-bootstrap'
import UserChangeSuccessComponent from './common/UserChangeSuccessComponent'
import Icon from 'react-fa'
import {t} from '../helpers/translate'
let config = require('config');

class User extends React.Component {

  constructor(props) {
    redirectIfNotLoggedIn();
    super(props);

    this.state = {
      userLoaded:false,

      editMode: false,
      loading: true,
      errors: Immutable.List(),

      showModal: false,
      showAlertModal: false,
      modalTitle: null,
      modalBody: null,

      data: Immutable.Map({}),
      backup: Immutable.Map({}),
      parsedForm: null,

      paymentSuccessful: null,
      savingChanges: false,
      sourceFullName: null,

      quoteRequestData: null,
      quoteResponseData: null,
      overridePremium: false,

      pwdError: false,
      optionsCmsSchools: null  //this isn't necessary but helps keep track of the dynamically loaded options
    }
  }

  componentWillMount() {
    if(this.getUserId()){
      this.loadData();
    } else {
      this.setState({
        editMode: !this.getUserId(),
        userLoaded: true,
      })
      this.parseForm()
    }
  }

  componentWillUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.location.reload();
    }
  }

  isMasterAdmin() {
    return sessionStorage.getItem('auth_level') == 'masteradmin'
  }

  isUserReadonly(){
    return sessionStorage.getItem('auth_level') == 'readonly';
  }

  getUserId() {
    return !this.props.location.state ? null : this.props.location.state.userId
  }

  isUserProfile() {
    return this.getUserId() == sessionStorage.getItem('user_id');
  }

  loadData() {
    $.when(
      request(`${config.default.auth_base_api}/member/${this.getUserId()}`, 'GET', null, this.loadUserData.bind(this)),
    ).done(this.parseForm.bind(this));
  }

  parseForm() {
    this.setState({
      parsedForm:
        config.default.user[sessionStorage.getItem('org')].expanded.reduce(
          (previousGroups, currentGroup) => {
            if (currentGroup.repeat) {
              for (let i = currentGroup.repeat.start; i < this.repeatCount(currentGroup); i++) {
                previousGroups.push(User.parseRepeatable(currentGroup, i));
              }
            } else {
              previousGroups.push(currentGroup);
            }
            return previousGroups;
          }, []
        ),
      loading: false
    });
  }

  static parseRepeatable(group, index) {
    return JSON.parse(
      JSON.stringify(group)
        .replace(/\*\+\+/g, String(index + 1))
        .replace(/\*/g, String(index))
    );
  }

  loadUserData(responseData, statusCode) {
    if (statusCode == 200) {
      let userData = Immutable.fromJS(responseData);
      this.setState({
        userLoaded: true,
        data: this.state.data.set('user', userData),
        backup: this.state.backup.set('user', userData)
      })
    } else {
      this.showModal(t('Error'), t('Unable to get application data'));
    }
  }

  isDataReady() {
    return this.state.userLoaded && this.state.parsedForm;
  }

  handleDataChange(delta) {
    this.setState({
      data: this.state.data.setIn(delta.key_path, delta.value),
      quoteResponseData: null
    })
  }

  handleModalClose() {
    this.setState({
        showModal: false
      }
    )
  }

  enableEditMode() {
    this.setState({editMode: true})
  }

  disableEditMode() {
    this.setState({editMode: false})
  }

  postChargeData(requestBody) {
    this.setState({paymentSuccessful: null});
    var quote = this.state.quoteResponseData;
    this.resetData();
    this.setState({paymentSuccessful: true});
    this.showModal(t('Success'),
      <UserChangeSuccessComponent
        quote={quote}
        isOverride={this.state.overridePremium}
        originalPremium={this.getOriginalPremium()}
      />
    );
  }

  makeQuoteRequestData() {
    let data = this.state.data.get('user').toJS();
    data.org = sessionStorage.getItem('org');
    return data
  }

  scrollToTheTop() {
    $('html, body').animate({scrollTop: 0}, 'fast');
  }

  checkPwdError(pwdError) {
    this.state.pwdError = pwdError
  }

  postQuoteRequestData(onSuccess) {

    let urlSuffix = '';
    let reqType = 'POST';

    if (this.getUserId()) {
      urlSuffix = this.getUserId()
      reqType = 'PATCH'
    }

    this.cleanErrors();
    let quoteRequestData = this.makeQuoteRequestData();

    this.setState({quoteRequestData: quoteRequestData, gettingQuote: true},
      () => {
        request(`${config.default.auth_base_api}/${'member'}/${urlSuffix}`, reqType, quoteRequestData, (data, statusCode) => {
          if (statusCode == 200) {
            this.props.location.state = {userId: data.id}
            this.setState({
                quoteResponseData: data
              }, () => {
                onSuccess(data)
              }
            );
          } else if (statusCode == 400) {
            this.scrollToTheTop();
            this.setState({
                errors: this.state.errors.concat(data.messages.map((m) =>
                  (() => {
                    return {
                      key: m.key,
                      message: m.message
                    }
                  })()
                ))
              }
            );
          } else {
            this.showModal('Error', t(`Unable to update user (Code ${statusCode}).`))
          }
          this.setState({savingChanges: false})
        })
      }
    );
  }

  resetData() {
    this.setState({
        quoteResponseData: null,
        loading: true,
        pwdError: false,
        showAlertModal: false
      }, function() {
        this.disableEditMode();
        this.cleanErrors();
        this.loadData();
      }
    );
  }

  cleanErrors() {
    this.setState({
      errors: Immutable.List(),
      paymentSuccessful: null
      }
    )
  }

  getOriginalPremium() {
    return this.state.data.getIn(['application', 'premium'])
  }

  repeatCount(group) {
    return this.state.data.getIn(group.repeat.key_path).count();
  }

  showModal(title, body) {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: title,
    })
  }

  showAlertModal(title, body, button, buttonAction) {
    this.setState({
      showAlertModal: true,
      alertModalBody: body,
      alertModalTitle: title,
      modalOptionalButton: t(button),
      modalAction: buttonAction
    })
  }

  renderButtonGroup () {
    return <ButtonGroup className="pull-right">
      {this.state.editMode ? this.renderEditModeButtons() : this.renderStaticModeButtons()}
    </ButtonGroup>
  }

  renderSaveButton () {
    return <button
      className="btn button-secondary"
      disabled={!this.state.data.get('user') || this.state.quoteResponseData || this.state.savingChanges}
      onClick={this.alertModal.bind(this)}>
      {this.state.savingChanges ? <Icon spin name="spinner"/> : <Icon name="save"/>}
      {` ${this.getUserId() ? t('Save Changes') : t('Create User')}`}
    </button>
  }

  renderEditModeButtons(){
    return [<Button
        disabled={this.state.quoteResponseData || this.state.savingChanges}
        onClick={this.alertModal.bind(this)}>
        {this.state.savingChanges ? <Icon spin name="spinner"/> : <Icon name="save"/>}
         {t('Save Changes')}
      </Button>,
      <Button onClick={this.resetData.bind(this)}>
        <Icon name="trash"/> {t('Discard Changes')}
      </Button>
    ]
  }

  renderStaticModeButtons(){
    return [<Button onClick={this.loadData.bind(this)}>
      <Icon name="refresh"/> {t('Reload')}
    </Button>,
    this.renderModifyButton()
    ]
  }

  renderModifyButton(){
    return (!this.isUserReadonly() || this.isUserProfile()) ? <Button onClick={this.enableEditMode.bind(this)}>
                <Icon name="edit"/> {t('Modify User')}
              </Button> : null
  }

  getButtons() {
    return <ButtonToolbar>
      {this.getReturnButton()}
      {this.getUserId() ? this.renderButtonGroup() : null}
      <div className='clearfix'></div>
    </ButtonToolbar>
  }

  getReturnButton() {
    return <button className="btn button-secondary" onClick={() => {window.history.back()}}>
      <Icon name="chevron-left"/> {t('Return to Search Results')}
    </button>
  }

  checkCondition(condition){
    if (condition.values) {
      return condition.values.includes(this.state.data.getIn(condition.key_path));
    }
    return this.state.data.getIn(condition.key_path) === condition.value
  }

  isStatic(field) {
    return (
      field.is_static_by_default ||
      !this.state.editMode ||
      this.isFieldPermanent(field) ||
      !this.canUserEditField(field)
    )
  }

  canUserEditField(field){
    return this.isMasterAdmin() || !field.edit_restricted;
  }

  isFieldPermanent(field){
    return this.getUserId() && field.is_permanent
  }

  hideInEditMode(item){
    return (item.hide_in_edit && this.state.editMode)
  }

  hideIfSomeIsTrue(item){
    return (item.do_not_show_if && item.do_not_show_if.some(this.checkCondition.bind(this)))
  }

  showIfEveryIsTrue(item){
    return (!item.show_if || item.show_if.some(this.checkCondition.bind(this)))
  }

  hideForUsers(item){
    return (item.hidden_to_non_admin && !this.isMasterAdmin())
  }

  updateOptions(savedOptionsState, options){
    this.setState({[savedOptionsState]: options})
  }

  getSavedOptions(savedOptionsState){
    return this.state[savedOptionsState];
  }

  fill(fields) {
    let elems = fields.map((field) => {
      if (
        this.hideInEditMode(field) ||
        this.hideIfSomeIsTrue(field) ||
        this.hideForUsers(field)
      ) {
      } else if (this.showIfEveryIsTrue(field)) {
        return (
          <div>
            <label className="text-uppercase">{t(field.as)}</label>
            <div>
              <FieldComponent
                ref={field.key_path}
                onDataChanged={this.handleDataChange.bind(this)}
                type={field.type}
                format={field.format}
                keyPath={field.key_path}
                keyPathAliases={field.key_path_aliases}
                options={field.options}
                optionsUrl={field.options_url}
                savedOptionsState={field.saved_options_state}
                updateOptions={this.updateOptions.bind(this)}
                getSavedOptions={this.getSavedOptions.bind(this)}
                isStatic={this.isStatic(field)}
                args={field.args}
                data={this.state.data}
                backup={this.state.backup}
                errors={this.state.errors}
                checkPwdError={this.checkPwdError.bind(this)}
                pwdError={this.state.pwdError}
                editMode={this.state.editMode}
                showFilter={field.show_filter}
                listSelected={field.list_selected}
              />
            </div>
          </div>
        );
      }
    });

    return makeGrids(3, elems.filter((elem) => elem));
  }

  saveChanges() {
    if(this.state.pwdError) {
      return
    }

    this.cleanErrors();
    this.setState({
      savingChanges: true
    }, () => {
      this.postQuoteRequestData((data) => {
        this.postChargeData({});
      })
    })
  }

  showAlertMessage() {
    return <div className='premium-override'><h5>{t('*** Changes to User Type will restore User Permissions to default Settings ***')}<br/>{t('This will impact Dashboard functionality and policies available for the user')}</h5></div>
  }

  alertModal() {
    if (this.getUserId() && (this.state.data.get('user').toJS().access_level != this.state.backup.get('user').toJS().access_level)) {
      !this.state.pwdError && this.showAlertModal(t('Alert'), this.showAlertMessage(), t('Save Changes'), this.saveChanges.bind(this));
    } else {
      this.saveChanges();
    }
  }

  getPageTitle () {
    return !this.getUserId() ? t('Create User') : this.state.editMode ? t('Modify User') : t('View User');
  }

  isGroupHidden (group) {
    return group.hidden || (group.hide_in_create_mode && !this.getUserId()) || (group.restricted_access && group.restricted_access.includes(getAccessLevel()))
  }

  showUserTypeMessage() {
    return <div className='premium-override'>** {t('Changes to User Type will restore User Permissions to default settings')} **</div>
  }

  render() {
    return this.isDataReady() ?
    <div className='container'>
      <div className="text-center bg-inherit">
        <h2 className='page-title row'>{this.getPageTitle()}</h2>
      </div>
      {this.showUserTypeMessage()}
      <Panel header={this.getButtons()}>
        <ListGroup fill>
          {
            this.state.editMode && this.state.errors.count() > 0 ?
              <ListGroupItem bsStyle="danger">
                <ul>{
                  this.state.errors.toArray().map(
                    (error, index) => <li key={index}>
                      {error.message}
                    </li>)}</ul>
              </ListGroupItem>
              : null
          }
          {
            this.state.parsedForm.map(
              (group, i) => {
                let groupElem = <ListGroupItem key={i}>
                  <div className='row'>
                    <div className='col-md-2'>
                      <label className='row-label'>{group.group_name}</label>
                    </div>
                    <div className='col-md-10'>
                      {group.fields && this.fill(group.fields)}
                    </div>
                  </div>
                </ListGroupItem>;
                return this.isGroupHidden(group) || (!this.showIfEveryIsTrue(group) || group.show_only_when === 'edit' && !this.state.editMode) || (group.show_only_when === 'view' && this.state.editMode) ?
                  null : groupElem;
              }
            )
          }
          {
            this.state.editMode ? <ListGroupItem>
              <div className="row">
                <div className="col-md-2"></div>
                <div className="col-md-10">
                  {this.renderSaveButton()}
                </div>
              </div>
            </ListGroupItem> : null
          }
        </ListGroup>
      </Panel>

      <LoadingComponent show={this.state.loading} />

      <ModalComponent
        title={this.state.modalTitle}
        body={this.state.modalBody}
        onClose={this.handleModalClose.bind(this)}
        show={this.state.showModal}
      />

      <ModalComponent
        title={this.state.alertModalTitle}
        body={this.state.alertModalBody}
        onClose={this.resetData.bind(this)}
        closeButton={t('Discard Changes')}
        show={this.state.showAlertModal}
        onSubmit={this.state.modalAction}
        buttonName={this.state.modalOptionalButton}
      />
    </div> : null;
  }
}
User.displayName = 'User';
export default User;



// WEBPACK FOOTER //
// ./src/components/User.js